import { MaintenanceOrder } from '../types/maintenance';

export const mockMaintenance: MaintenanceOrder[] = [
  {
    id: 'MNT001',
    orderNumber: 'WO-2026-001',
    shipId: 'SHP004',
    shipName: '설악호',
    title: 'LNG 탱크 정기 검사',
    description: 'IMO 규정에 따른 LNG 화물탱크 내부 정기 검사 및 안전밸브 점검',
    type: '정기점검',
    status: '진행중',
    priority: '높음',
    assignedTo: '김기술',
    scheduledDate: '2026-02-10',
    estimatedCost: 45000000,
    parts: ['안전밸브', '가스켓', '압력게이지'],
  },
  {
    id: 'MNT002',
    orderNumber: 'WO-2026-002',
    shipId: 'SHP001',
    shipName: '한라호',
    title: '주기관 오버홀',
    description: '주기관 12,000시간 운전 후 정기 오버홀 작업',
    type: '정기점검',
    status: '예정',
    priority: '높음',
    assignedTo: '박정비',
    scheduledDate: '2026-03-15',
    estimatedCost: 120000000,
    parts: ['피스톤링', '실린더라이너', '크랭크샤프트 베어링', '연료분사밸브'],
  },
  {
    id: 'MNT003',
    orderNumber: 'WO-2026-003',
    shipId: 'SHP003',
    shipName: '지리산호',
    title: '카고펌프 긴급 수리',
    description: '화물유 양하 중 카고펌프 #2 이상 진동 발생으로 긴급 수리 필요',
    type: '긴급수리',
    status: '진행중',
    priority: '긴급',
    assignedTo: '이수리',
    scheduledDate: '2026-02-15',
    estimatedCost: 28000000,
    parts: ['임펠러', '메카니컬씰', '베어링'],
  },
  {
    id: 'MNT004',
    orderNumber: 'WO-2026-004',
    shipId: 'SHP002',
    shipName: '백두호',
    title: '해치커버 수밀 검사',
    description: '화물창 해치커버 수밀 시험 및 고무패킹 교체',
    type: '검사',
    status: '예정',
    priority: '보통',
    assignedTo: '최검사',
    scheduledDate: '2026-02-28',
    estimatedCost: 8500000,
    parts: ['고무패킹', '클리트볼트'],
  },
  {
    id: 'MNT005',
    orderNumber: 'WO-2026-005',
    shipId: 'SHP005',
    shipName: '태백호',
    title: '냉동컨테이너 전원 패널 교체',
    description: '리퍼 컨테이너 전원 공급 패널 4개소 노후 교체',
    type: '부품교체',
    status: '완료',
    priority: '보통',
    assignedTo: '정전기',
    scheduledDate: '2026-01-20',
    completedDate: '2026-01-22',
    estimatedCost: 15000000,
    actualCost: 14200000,
    parts: ['전원패널', '차단기', '케이블'],
  },
  {
    id: 'MNT006',
    orderNumber: 'WO-2026-006',
    shipId: 'SHP007',
    shipName: '독도호',
    title: '발라스트 수처리 장치 점검',
    description: 'BWM 협약 준수를 위한 발라스트 수처리 장치 정기 점검',
    type: '정기점검',
    status: '예정',
    priority: '보통',
    assignedTo: '한환경',
    scheduledDate: '2026-03-20',
    estimatedCost: 12000000,
    parts: ['UV 램프', '필터 카트리지', 'O-링'],
  },
  {
    id: 'MNT007',
    orderNumber: 'WO-2025-048',
    shipId: 'SHP006',
    shipName: '금강호',
    title: '5년 도크 입거',
    description: '선급 특별검사를 위한 정기 도크 입거 - 선체 도장, 프로펠러 검사',
    type: '도크입거',
    status: '완료',
    priority: '높음',
    assignedTo: '조도크',
    scheduledDate: '2025-12-01',
    completedDate: '2025-12-28',
    estimatedCost: 350000000,
    actualCost: 380000000,
    parts: ['도료', '아연블록', '프로펠러 씰'],
  },
  {
    id: 'MNT008',
    orderNumber: 'WO-2026-007',
    shipId: 'SHP008',
    shipName: '울릉호',
    title: '자동차 데크 유압장치 수리',
    description: '차량 적재 데크 승강 유압 실린더 오일 누유 수리',
    type: '긴급수리',
    status: '지연',
    priority: '긴급',
    assignedTo: '김유압',
    scheduledDate: '2026-02-05',
    estimatedCost: 22000000,
    parts: ['유압실린더', '유압호스', '오일씰'],
  },
  {
    id: 'MNT009',
    orderNumber: 'WO-2026-008',
    shipId: 'SHP009',
    shipName: '한강호',
    title: '화물유 가열 코일 교체',
    description: '화물창 #3, #4 가열 코일 부식으로 교체 필요',
    type: '부품교체',
    status: '예정',
    priority: '높음',
    assignedTo: '박교체',
    scheduledDate: '2026-03-10',
    estimatedCost: 55000000,
    parts: ['가열코일', '플랜지', '개스킷'],
  },
  {
    id: 'MNT010',
    orderNumber: 'WO-2026-009',
    shipId: 'SHP010',
    shipName: '소백호',
    title: 'BOG 압축기 성능 검사',
    description: 'Boil-Off Gas 압축기 성능 저하 의심, 정밀 진단 필요',
    type: '검사',
    status: '예정',
    priority: '높음',
    assignedTo: '이진단',
    scheduledDate: '2026-03-25',
    estimatedCost: 18000000,
    parts: ['진동센서', '가스분석기 캘리브레이션'],
  },
  {
    id: 'MNT011',
    orderNumber: 'WO-2025-047',
    shipId: 'SHP001',
    shipName: '한라호',
    title: '항해등 LED 교체',
    description: '마스트 항해등 및 현등 LED 전구 교체',
    type: '부품교체',
    status: '완료',
    priority: '낮음',
    assignedTo: '최전기',
    scheduledDate: '2025-12-10',
    completedDate: '2025-12-10',
    estimatedCost: 2500000,
    actualCost: 2300000,
    parts: ['LED 전구', '방수커넥터'],
  },
  {
    id: 'MNT012',
    orderNumber: 'WO-2026-010',
    shipId: 'SHP004',
    shipName: '설악호',
    title: '스러스터 모터 절연 검사',
    description: '바우 스러스터 전동기 절연저항 측정 및 권선 상태 점검',
    type: '검사',
    status: '진행중',
    priority: '보통',
    assignedTo: '한전기',
    scheduledDate: '2026-02-12',
    estimatedCost: 5000000,
    parts: [],
  },
];
